import { Http } from '@gamiphy/http';
import { Tier, TierConfig } from '@gamiphy/bl/level';

export class LevelApi {
  public static async getUserLevel(userId: string): Promise<UserLevelResponse> {
    const response = await Http.get<UserLevelResponse>({
      url: `v2/users/user-progress/${userId}`,
    });
    return response.data;
  }

  public static async createTier(tier: Omit<Tier, 'id' | 'app'>): Promise<Tier> {
    const response = await Http.post<CreateTierResponse>({
      url: '/v2/tiers',
      payload: tier,
    });
    return response.data.tier;
  }

  public static async getTiers(): Promise<Tier[]> {
    const response = await Http.get<GetTiersResponse>({
      url: '/v2/tiers',
    });
    return response.data.tiers;
  }

  public static async updateTier(id: string, data: Partial<Tier>): Promise<Tier> {
    const response = await Http.patch<updateTiersResponse>({
      url: `/v2/tiers/${id}`,
      payload: data,
    });
    return response.data.tier;
  }

  public static async deleteLevelAndTier(tierId?: string): Promise<void> {
    if (tierId) {
      await Http.delete({
        url: `v2/tiers/${tierId}`,
      });
    }
  }

  public static async getTierConfig(): Promise<TierConfig> {
    const response = await Http.get<GetTiersConfigResponse>({
      url: '/v2/tier-config',
    });
    return response.data.config;
  }

  public static async createTierConfig(data: Partial<TierConfig>): Promise<TierConfig> {
    const response = await Http.post<GetTiersConfigResponse>({
      url: '/v2/tier-config',
      payload: data,
    });
    return response.data.config;
  }

  public static async updateTierConfig(id: string, data: Partial<TierConfig>): Promise<TierConfig> {
    const response = await Http.patch<GetTiersConfigResponse>({
      url: `/v2/tier-config/${id}`,
      payload: data,
    });
    return response.data.config;
  }
}

export type UserLevelResponse = {
  current: Tier,
  next?: Tier,
  progress: number
  accumulated: number,
}

export type CreateTierResponse = {
  tier: Tier,
}

export type GetTiersResponse = {
  tiers: Tier [],
  count: number
}

export type updateTiersResponse = {
  tier: Tier,
}

export type GetTiersConfigResponse = {
  config: TierConfig,
}
